import(/* webpackMode: "eager" */ "/codebuild/output/src3399664712/src/apps/web/app/[locale]/error.tsx");
